import app from '../app';

class ProductImageController {

    /*@ngInject*/
    constructor() {
        this.class = 'img-responsive';
        this.height = 340;
        this.width = '';
    }

    $onInit() {
        this.class = this.class || 'img-responsive';
        this.imageUrl = this.getProductImage(this.product, this.resizedUrl);
    }

    getProductImage(product, resizedUrl) {
        let imageSource = '/static/images/cover-placeholder.png';
        if (product.imageurl) {
            imageSource = product.imageurl;
        }
        if (product.main_image) {
            if (product.main_image.url) {
                imageSource = product.main_image.url;
            } else {
                imageSource = product.main_image;
            }
        }
        if (resizedUrl) {
            imageSource = resizedUrl;
        }
        if (imageSource.indexOf('?') === -1) {
            imageSource = imageSource + '?h=' + this.height + '&w=' + this.width;
        }
        return encodeURI(imageSource);
    }
}

app.component('productImage', {
    bindings: {
        product: '=',
        resizedUrl: '=',
        title: '@',
        class: '=?',
        width: '=?',
        height: '=?'
    },
    template: `<img ng-src="{{ $ctrl.imageUrl }}" src="/static/images/cover-placeholder.png" title="{{ $ctrl.title }}" class="{{ $ctrl.class }}" />`,
    controller: ProductImageController
});


// WEBPACK FOOTER //
// ./static/js/app/components/product-image.component.js